import { DateTime } from 'luxon';
import { type } from '@mews-framework/utils';
import { ISOFormat } from '../enums';

interface WallClockDate {
    value: string;
}

function WallClockDate(luxon: DateTime): WallClockDate {
    return type.create(WallClockDate, {
        value: luxon.toFormat(ISOFormat.Date),
    });
}

export default WallClockDate;
